import { inject, Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { LanguageService } from '@pxl/shared/translation';
import { Title } from '@angular/platform-browser';
import { CONFIG_TOKEN, IConfig } from '@pxl/models/common';

@Injectable()
export class TranslatedTitleStrategy extends TitleStrategy {
    private readonly title = inject(Title);

    private readonly config: IConfig = inject(CONFIG_TOKEN);
    private readonly languageService = inject(LanguageService);

    public override updateTitle(routerState: RouterStateSnapshot): void {
        const title = this.buildTitle(routerState);
        if (title) {
            const translatedTitle = this.languageService.translate(title);
            this.title.setTitle(translatedTitle);
        } else {
            const appName = this.config.AppDisplayName;
            this.title.setTitle(appName);
        }
    }
}
